/**
 * Helpers para formateo numérico que toleran inputs string|number|null|undefined.
 * Necesario porque Prisma Decimal serializa como string en JSON.
 */

export function toNum(v: unknown): number {
  if (typeof v === 'number') return v
  if (typeof v === 'string' && v.trim() !== '') {
    const n = parseFloat(v)
    return Number.isFinite(n) ? n : 0
  }
  return 0
}

/** Formato fijo con N decimales. Si v es string lo convierte. Si es null/undefined → '0.00'. */
export function fixed(v: unknown, decimals = 2): string {
  return toNum(v).toFixed(decimals)
}

/** Formato número con separadores de miles (1234.5 → "1.234,5"). Locale es-BO. */
export function num(v: unknown, decimals = 2): string {
  return toNum(v).toLocaleString('es-BO', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

/** Formato moneda BOB (Bs. 1.234,50). */
export function bs(v: unknown, decimals = 2): string {
  return `Bs. ${num(v, decimals)}`
}

/** Formato litros: "320 L" (sin decimales) o "320,5 L" si tiene fracción. */
export function litros(v: unknown, decimals = 0): string {
  return `${num(v, decimals)} L`
}

/** Porcentaje: 0.045 → "4,5%". */
export function pct(v: unknown, decimals = 1): string {
  return `${num(toNum(v) * 100, decimals)}%`
}

/** Distancia metros: 1234 → "1,23 km" o 234 → "234 m". */
export function distancia(v: unknown): string {
  const m = toNum(v)
  if (m >= 1000) return `${num(m / 1000, 2)} km`
  return `${num(m, 0)} m`
}
